<script>
import auth from '@/services/auth'
import gql from 'graphql-tag'

import { initVueGtm } from '@/services/gtm'

const GET_COUNTRIES = gql`
  query myUser {
    myUser {
      shops {
        country
      }
    }
  }
`

const GET_MY_USER = gql`
  query getMyUser {
    myUser {
      shops {
        shopUuid
      }
    }
  }
`

export default {
  name: 'AutoLogin.vue',

  async beforeCreate() {
    const { email, hash, issued, ttl } = this.$route.query

    if (email && hash && issued && ttl) {
      try {
        // remove existing credentials if any
        this.$store.commit('RESET_STORE')
        await auth.logout()

        const { ecpId } = await auth.autologin(email, hash, Number.parseInt(issued), Number.parseInt(ttl))

        if (!this.$gtm) {
          const { data } = await this.$apollo.query({ query: GET_COUNTRIES })
          initVueGtm(data.myUser.shops[0].country)
        }

        const userResponse = await this.$apollo.query({ query: GET_MY_USER })

        this.$gtm &&
          this.$gtm.trackEvent({
            event: 'Sign_in',
            essilor_client_id: ecpId,
            practitioner_id: ecpId,
            shopUuid: userResponse.data.myUser.shops[0].shopUuid
          })

        await this.$router.push({ name: 'Home' })
      } catch (error) {
        this.$router.push({ name: 'Login' })
      }
    } else {
      this.$router.push({ name: 'Login' })
    }
  }
}
</script>
